<template v-if="userData ==true">
  <v-container fluid>
    <v-app-bar
      :collapse="collapseStatus"
      :clipped-left="true"
      v-bind:style="{'z-index':2000,'background-color': (Object.keys(currentUser).length !=0 ? JSON.parse(currentUser.company.company_meta).primary_color : '')}"
      app
      dark
    >
      <v-app-bar-nav-icon @click.stop="status" />
      <v-toolbar-title class="ml-0 pl-4">
        <span class="hidden-xs-and-down">
          <img style="height:22px" class="mt-1" :src="companylogo" /></span>
      </v-toolbar-title>
      <v-spacer />
    
      <v-toolbar-items>
        <span class="pa-5">
        {{"Welcome" | translate}} <b>{{ currentUser.salutation }} {{ currentUser.name }}</b>.
        </span>
        <v-select
          @change="changedLanguage"
          v-model="selectedLanguage.lang_code"
          :items="languagesdata"
          item-value="lang_code"
          :item-text="'lang_name' | translate"
          :label="'Language' | translate"
          outlined
          dense
          class="pt-3 d-none d-sm-flex"
          style="width:140px;"
        ></v-select>
      </v-toolbar-items>
      <v-btn class="d-none d-sm-flex" icon large>
        <v-icon large @click="contact = true">mdi-send</v-icon>
      </v-btn>

      <v-menu
        :close-on-content-click="false"
        offset-y
        bottom
        origin="center center"
        transition="scale-transition"
      >
        <template v-slot:activator="{ on }">
          <v-btn icon large v-on="on">
            <v-icon large>mdi-account</v-icon>
          </v-btn>
        </template>
        <v-list 
        style="max-height: 600px; overflow-y: scroll"
        >
          <v-list-item class="d-flex d-sm-none">
            <v-list-item-content>
              <v-select
                @change="changedLanguage"
                v-model="selectedLanguage.lang_code"
                :items="languagesdata"
                item-value="lang_code"
                item-text="lang_name"
                :label="'Language' | translate"
                dense
                class="d-flex d-sm-none"
              ></v-select>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="d-flex d-sm-none">
            <v-list-item-action>
              <v-icon large>mdi-telegram</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ 'Contact us' | translate }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider class="d-flex d-sm-none"></v-divider>
          <v-list-item v-for="(item, index) in dropdown" :key="index" @click="action(item.action,item.type)">
            <v-list-item-action>
              <v-icon large>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text | translate }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-navigation-drawer
      v-model="openDrawer"
      permanent
      :mini-variant-width="widthValue"
      :mini-variant.sync="mini"
      :clipped="true"
      app
    >
      <v-list dense>
        <template v-for="item in items">
          <v-list-group
            v-if="item.children"
            :key="item.text"
            v-model="item.model"
          >
            <template v-slot:activator>
              <v-list-item :style='(mini == false ? "padding: 0px;" : "")'>
                <v-list-item-action>
                  <v-icon large :color="(Object.keys(currentUser).length !=0 ? JSON.parse(currentUser.company.company_meta).primary_color: '')">{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ item.text | translate }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list-item v-for="(child, i) in item.children" :to="child.link" :key="child.text+i" link>
              <v-list-item-action v-if="child.icon ">
                <v-icon :style='(mini == false ? "margin-left: 20px;" : "")' :color="(Object.keys(currentUser).length !=0 ? JSON.parse(currentUser.company.company_meta).primary_color: '')">{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ child.text | translate }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item v-else :key="item.text" :to="item.link" link>
            <v-list-item-action>
              <v-icon large :color="(Object.keys(currentUser).length !=0 ? JSON.parse(currentUser.company.company_meta).primary_color: '')">{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content v-if="item.text=='Inbox' && inboxMessagesCount>0">
              <v-list-item-title>{{ item.text | translate }} 
                <span class="badge"> <v-icon small style="color: #28d328"> mdi-checkbox-blank-circle</v-icon></span> </v-list-item-title>
            </v-list-item-content>
            <v-list-item-content v-else>
              <v-list-item-title>{{ item.text | translate }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-row justify="center">
      <v-dialog v-model="contact" max-width="500">
        <v-card>
          <v-card-title v-if="isCompanyRep" class="headline">{{ 'Send Message to Group/Users' | translate }}</v-card-title>
          <v-card-title v-else-if="canSendMessages" class="headline">{{ 'Send Message to Users' | translate }}</v-card-title>
          <v-card-title v-else class="headline">{{ 'Write to Company Representatives' | translate }}</v-card-title>
          <v-card-text>
            <v-row v-if="message!== null">
              <v-col cols="12" sm="12">
                <v-alert dense outlined type="success">{{ message | translate }}</v-alert>
              </v-col>
            </v-row>
            <v-form ref="contactForm" lazy-validation>
              <div v-if="isCompanyRep">
                <v-row>
                  <v-col cols="12" sm="12">
                  <v-autocomplete
                      v-model="sendGroup"
                      :items="recipientType"
                      item-value="value"
                      item-text="text"
                      :label="'Select Recipient Type' | translate"
                      outlined
                      chips
                      small-chips
                      required
                      :no-data-text="$t('No data available')"
                      >
                      <template #message="{ message }">
                      {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                      </template>
                    </v-autocomplete>
                </v-col>
                </v-row>

                <div v-if="sendGroup">
                <v-row v-if="sendGroup=='group'">
                  <v-col cols="12" sm="12">
                    <v-autocomplete
                      v-model="userGroupList"
                      :items="groups"
                      item-value="group_id"
                      :item-text="item =>`${item.group_name}`"
                      :label="'User Group' | translate"
                      outlined
                      chips
                      small-chips
                      multiple
                      required
                      :no-data-text="$t('No data available')"
                    >
                    <template #message="{ message }">
                      {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                    </template>  

                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row v-else>
                  <v-col cols="12" sm="12">
                    <v-autocomplete
                      v-model="userList"
                      :items="users"
                      item-value="user_id"
                      :item-text="item =>`${item.name} (${item.email})`"
                      :label="'Users' | translate"
                      outlined
                      chips
                      small-chips
                      multiple
                      required
                      :no-data-text="$t('No data available')"
                    >
                    <template #message="{ message }">
                      {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                    </template>  

                    </v-autocomplete>
                  </v-col>
                </v-row>
                </div>
              </div>

              <div v-if="canSendMessages">
                  <v-row v-if="users.length">
                      <v-col cols="12" sm="12">
                      <v-autocomplete
                      v-model="userList"
                      :items="users"
                      item-value="user_id"
                      :item-text="item =>`${item.name} (${item.email})`"
                      :label="'Users' | translate"
                      outlined
                      chips
                      small-chips
                      multiple
                      required
                      :no-data-text="$t('No data available')"
                      >
                      <template #message="{ message }">
                      {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                      </template>  

                      </v-autocomplete>
                  </v-col>
                  </v-row>

              </div>

              <v-row>
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="subject"
                    name="subject"
                    :rules="[v => !!v || 'Subject is required']"
                    :label=" 'Subject' | translate"
                    required
                  >
                  <template #message="{ message }">
                    {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                  </template>                  
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12">
                  <v-textarea
                    outlined
                    name="body"
                    v-model="body"
                    :rules="[v => !!v || 'Body is required']"
                    :label=" 'Body' | translate"
                  >
                  <template #message="{ message }">
                    {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                  </template>                   
                  </v-textarea>
                </v-col>
              </v-row>

              <v-checkbox v-model="sendCopy" :label="'Send copy to myself' | translate"></v-checkbox>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary darken-1" text @click="contact = false">{{ 'Close' | translate}}</v-btn>

            <v-btn color="primary darken-1" text @click="contactQuery">{{ 'Submit' | translate }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

       <v-dialog v-model="navSuccessMessageDialog" persistent max-width="560">
        <v-card>
          <v-card-title class="headline">{{ message| translate }}</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" text @click="navSuccessMessageDialog = false">{{ 'Close'| translate }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-row>
  </v-container>
</template>

<script>
import Vue from "vue";
import store from "@/store";
import {
  LOGOUT,
  FETCH_PAGES,
  FETCH_ADDITIONAL_PAGES,
  FETCH_ADDITIONAL_PAGES_ON_SIDE_MENU,
  STRIPE_RESET_STATE,
  PAGES_RESET_STATE,
  CONTACT_QUERY,
  RESET_STATE,
  FETCH_NAVIGATION_BAR_STATUS,
  GLOBALS_RESET_STATE,
  UPDATE_USER_STATUS,
  FETCH_USERS,
  FETCH_GROUPS,
  UPDATE_CUR_USER_LANG
} from "@/store/actions.type";
import {
  SET_CUR_LANGUAGE,
  SET_LOADING,
  SET_NAVBAR_WIDTH,
  RESET_ALL_PAGES_DATA,
  RESET_ALL_ADDITIONAL_PAGES_DATA,
  SET_LOGGED_IN,
} from "@/store/mutations.type";
import { mapGetters } from "vuex";
export default {
  name: "Navbar",
  props: {
    source: String
  },
  watch: {
    async $route(to) {
      if (to.name === "moduleplayer") {
        window.removeEventListener("resize", this.onResize);
        await store.commit(SET_NAVBAR_WIDTH, 0);
      } else {
        this.onResize();
        window.addEventListener("resize", this.onResize, { passive: true });
      }
    },
    async contact(value) {
      if (value) {
        this.message = null;
        this.body = null;
        this.subject = null;
        this.sendCopy = false;
        this.sendGroup = null;
        this.userGroupList = null;
        this.userList = null;

        // Call the users and groups api for only people with access
            await this.$store.dispatch(FETCH_USERS, '?filter=message').then(resp => {
              if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
                this.$store.commit(SET_LOADING, false);
                this.users = resp.data;
              }
              else{
                this.$store.commit(SET_LOADING, false);
              }
            });

         if(this.currentUser.roles.includes(1) || this.currentUser.roles.includes(3) || this.currentUser.permissions.includes('can-send-receive-messages') ){
            await this.$store.dispatch(FETCH_GROUPS, '').then(resp => {
              if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
                this.$store.commit(SET_LOADING, false);
                this.groups = resp.data;
              }
              else{
                this.$store.commit(SET_LOADING, false);
              }
            });
          }
      }
    },
    languages(value){
      if(Object.keys(value).length>0){
        this.setLanguageDropdown();
      }
    },
    pagesdata(){
        this.setDropdown()      
    },
    additionalpages(){
        this.setDropdown()      
    },
    additionalpagessidemenu(){
        this.setDropdown()      
    },
  },
  data: () => ({
    dialog: false,
    drawer: true,
    isMobile: false,
    selectedLanguage: "",
    companylogo: null,
    items: [],
    dropdown: [],
    sideMenuAddPages: [],
    contact: false,
    sendCopy: false,
    sendGroup: false,
    collapseStatus: false,
    subject: "",
    body: "",
    message: null,
    navSuccessMessageDialog:false,
    closeOnClick: true,
    closeOnContentClick: false,
    userData: null,
    userList:[],
    userGroupList:[],
    users:[],
  }),
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  created(){
    this.setLanguageDropdown()
    this.setSidebar()
  },
  methods: {
    async setLanguageDropdown(){
      this.currentUser.lang_code==="de" ? 
      this.selectedLanguage = { "lang_id": 2, "lang_name":"German", "lang_code":"de"}
      : this.selectedLanguage = { "lang_id": 1, "lang_name":"English", "lang_code":"en"}

      this.selLanguage(this.selectedLanguage)
      Vue.i18n.set(this.curLanguage.lang_code)  
      this.setDropdown()      
      
    },
    setSidebar() {
      this.items = [];
      this.companylogo = process.env.VUE_APP_STORAGE_URL+this.currentUser.company.company_logo;
      let companymeta = JSON.parse(this.currentUser.company.company_meta);
  
      /****************** Inbox *************/
      if(((this.currentUser.roles.includes(1) || this.currentUser.roles.includes(3) || this.currentUser.roles.includes(4)) && companymeta.has_inbox == "true" ) || 
      (this.currentUser.is_group_user && companymeta.has_inbox == "true" && !this.currentUser.roles.includes(6))){
        this.items.push({ icon: "mdi-inbox", text: "Inbox", link: "/inbox" })
      }

      if(this.currentUser.roles.includes(5)) {
        this.items.push({ icon: "mdi-test-tube", text: "Drafts", link: "/drafts" })
      }

      /****************** Learning *************/
      if(this.currentUser.roles.includes(1) || this.currentUser.roles.includes(3)
        || this.currentUser.roles.includes(4)){
        this.items.push(
            {
            icon: 'mdi-book',
            text: 'Learning',
            model: false,
            children: [
              { icon: "mdi-home", text: "Dashboard", link: "/dashboard" },
              { icon: "mdi-calendar", text: "Calendar", link: "/calendar" },
              { icon: "mdi-file", text: "Courses", link: "/courses" },
              { icon: "mdi-file-document", text: "Learning material", link: "/learningmaterial" },
              { icon: "mdi-frequently-asked-questions", text: "Test-center", link: "/test-center" },
            ],
          }
        )

        this.sideMenuAddPages.forEach(extrapage => 
          this.items[this.items.findIndex(o=>o.text == 'Learning')]['children'].push({ icon: (extrapage.page_type=='blank' ? "mdi-file-outline" : extrapage.page_type=='glossary' ? 'mdi-clipboard-list' : 'mdi-account-question') , text: extrapage.page_names[0] ? extrapage.page_names[0].page_name : '', link: "/companypages/"+extrapage.page_id })
        )
      }
      else if(this.currentUser.roles.includes(6)){
        this.items.push(
            {
            icon: 'mdi-book',
            text: 'Learning',
            model: false,
            children: [
              { icon: "mdi-home", text: "Dashboard", link: "/dashboard" },
              { icon: "mdi-file", text: "Courses", link: "/courses" },
              { icon: "mdi-file-document", text: "Learning material", link: "/learningmaterial" },
              { icon: "mdi-frequently-asked-questions", text: "Test-center", link: "/test-center" },
            ],
          }
        )
      }


      /****************** Statistics *************/
      if(this.currentUser.roles.includes(1) || this.currentUser.roles.includes(3) || this.currentUser.permission_labels.includes('statistics') ){
        
        
        if (companymeta.show_statistics == "true") {
          this.items.push(
              {
              icon: 'mdi-chart-bar',
              text: 'Statistics',
              model: false,
              children: [
              ],
            }
          )

          if(( (this.currentUser.roles.includes(1)) || this.currentUser.permissions.includes('has-access-to-all-statistics') || this.currentUser.permissions.includes('has-access-to-course-statistics')) ){
            this.items[this.items.findIndex(o=>o.text == 'Statistics')]['children'].push({ icon: "mdi-chart-arc", text: "Course Stats", link: "/coursesstats" })
          }

          if(( (this.currentUser.roles.includes(1)) || this.currentUser.permissions.includes('has-access-to-all-statistics') || this.currentUser.permissions.includes('has-access-to-group-statistics')) ){
            this.items[this.items.findIndex(o=>o.text == 'Statistics')]['children'].push({ icon: "mdi-chart-line", text: "Group Stats", link: "/groupstats" })
          }

        }
      }

      
      /****************** Equipment *************/
      if (companymeta.has_equip_db == "true") {
            if(this.currentUser.roles.includes(1) || this.currentUser.permission_labels.includes('equipment-template') || this.currentUser.permission_labels.includes('equipment-group') || this.currentUser.permission_labels.includes('equipment') ){

              this.items.push(
                  {
                    icon: 'mdi-factory',
                    text: 'Equipment',
                    model: false,
                    children: [
                    ],
                }
              )

              if(( (this.currentUser.roles.includes(1)) || this.currentUser.permissions.includes('can-create-equipment-template') || this.currentUser.permissions.includes('can-update-equipment-template') || this.currentUser.permissions.includes('can-delete-equipment-template')) ){
                this.items[this.items.findIndex(o=>o.text == 'Equipment')]['children'].push({ icon:'mdi-file-document', text: 'Equipment Template', link: '/equipment-template' })
              }

              if(( (this.currentUser.roles.includes(1)) || this.currentUser.permissions.includes('can-create-equipment') || this.currentUser.permissions.includes('can-update-equipment') || this.currentUser.permissions.includes('can-delete-equipment')) ){
                this.items[this.items.findIndex(o=>o.text == 'Equipment')]['children'].push({ icon:'mdi-format-list-bulleted-square', text: 'Items', link: '/equipment' })
              }

              if(( (this.currentUser.roles.includes(1)) || this.currentUser.permissions.includes('can-create-equipment-group') || this.currentUser.permissions.includes('can-update-equipment-group') || this.currentUser.permissions.includes('can-delete-equipment-group')) ){
                this.items[this.items.findIndex(o=>o.text == 'Equipment')]['children'].push({ icon:'mdi-account-group-outline', text: 'Equipment Group', link: '/equipment-group' })
              }
            }
      }

       /****************** Task Center *************/
       if (companymeta.has_task_center == "true") {
            if(this.currentUser.roles.includes(1) || this.currentUser.permission_labels.includes('test-case-template') || this.currentUser.permission_labels.includes('test-case-group') || this.currentUser.permission_labels.includes('test-case') ){

              this.items.push(
                  {
                    icon: 'mdi-file',
                    text: 'Task Center',
                    model: false,
                    children: [
                    ],
                }
              )

              if(( (this.currentUser.roles.includes(1)) || this.currentUser.permissions.includes('can-create-test-case-template') || this.currentUser.permissions.includes('can-update-test-case-template') || this.currentUser.permissions.includes('can-delete-test-case-template')) ){
                this.items[this.items.findIndex(o=>o.text == 'Task Center')]['children'].push({ icon:'mdi-file-outline', text: 'Task Template', link: '/task-center-template' })
              }

              if(( (this.currentUser.roles.includes(1)) || this.currentUser.permissions.includes('can-create-test-case') || this.currentUser.permissions.includes('can-update-test-case') || this.currentUser.permissions.includes('can-delete-test-case')) ){
                this.items[this.items.findIndex(o=>o.text == 'Task Center')]['children'].push({ icon:'mdi-file-document', text: 'Tasks', link: '/task-center' })
              }

              if(( (this.currentUser.roles.includes(1)) || this.currentUser.permissions.includes('can-create-test-case-group') || this.currentUser.permissions.includes('can-update-test-case-group') || this.currentUser.permissions.includes('can-delete-test-case-group')) ){
                this.items[this.items.findIndex(o=>o.text == 'Task Center')]['children'].push({ icon:'mdi-format-list-bulleted-square', text: 'Task Group', link: '/task-center-group' })
              }
            }
      }

  
      /****************** User Group *************/
      if(this.currentUser.roles.includes(1) || this.currentUser.permission_labels.includes('personal-template') || this.currentUser.permission_labels.includes('group')  ){

        this.items.push(
            {
              icon: 'mdi-group',
              text: 'User Group',
              model: false,
              children: [
              ],
          }
        )

        if(( (this.currentUser.roles.includes(1)) || this.currentUser.permissions.includes('can-create-personal-template') || this.currentUser.permissions.includes('can-update-personal-template') || this.currentUser.permissions.includes('can-delete-personal-template')) ){
          this.items[this.items.findIndex(o=>o.text == 'User Group')]['children'].push({ icon:'mdi-file-document', text: 'Personal Template', link: '/personal-template' })
        }

        if(( (this.currentUser.roles.includes(1)) || this.currentUser.permissions.includes('can-create-group') || this.currentUser.permissions.includes('can-update-group') || this.currentUser.permissions.includes('can-delete-group')) ){
          this.items[this.items.findIndex(o=>o.text == 'User Group')]['children'].push({ icon:'mdi-format-list-bulleted-square', text: 'All Groups', link: '/groups' })
        }
      }

      
      
      /****************** Admin *************/
      if(this.currentUser.roles.includes(1) || this.currentUser.roles.includes(3) || ((this.currentUser.permission_labels.includes('question') || this.currentUser.permission_labels.includes('user') || this.currentUser.permission_labels.includes('custom-role') || this.currentUser.permission_labels.includes('additional-pages') || this.currentUser.permission_labels.includes('custom-email-scheduling') || this.currentUser.permission_labels.includes('quiz')) &&(companymeta.has_quiz == "true") && !this.currentUser.permissions.includes('can-send-receive-messages')) ){
          this.items.push(
              {
              icon: 'mdi-security',
              text: 'Admin',
              model: false,
              children: [
              ],
            }
          )
      }

      if(( (this.currentUser.roles.includes(1)) || this.currentUser.permission_labels.includes('custom-role')) ){
        this.items[this.items.findIndex(o=>o.text == 'Admin')]['children'].push({ icon: "mdi-account-supervisor", text: "Custom Role", link: "/custom-role" })
      }

      if((this.currentUser.roles.includes(1) || this.currentUser.roles.includes(3)) || this.currentUser.permission_labels.includes('user') && !this.currentUser.permissions.includes('can-send-receive-messages')){
        this.items[this.items.findIndex(o=>o.text == 'Admin')]['children'].push({ icon: "mdi-account-box", text: "Users", link: "/users" })
      }

      if(this.currentUser.roles.includes(1) && (companymeta.has_external_users == "true")){
        this.items[this.items.findIndex(o=>o.text == 'Admin')]['children'].push({ icon: "mdi-account-outline", text: "External Users", link: "/ext-users" })
      }

      if((this.currentUser.roles.includes(1) || this.currentUser.permission_labels.includes('question')) && (companymeta.has_quiz == "true")){
        this.items[this.items.findIndex(o=>o.text == 'Admin')]['children'].push({ icon: "mdi-help", text: "Questions", link: "/questions" })
      }
       
      if((this.currentUser.roles.includes(1) || this.currentUser.permission_labels.includes('quiz')) && (companymeta.has_quiz == "true") ){
        this.items[this.items.findIndex(o=>o.text == 'Admin')]['children'].push({ icon: "mdi-frequently-asked-questions", text: "Quiz", link: "/quiz" })
      }

      let linktoadditonalpages = '/additional-pages';
      if(this.currentUser.roles.includes(1) || this.currentUser.permission_labels.includes('additional-pages')){

        if(this.currentUser.permissions.includes('has-access-to-additional-pages-resource')){
          linktoadditonalpages = "/resources";
        }

        if(this.currentUser.permissions.includes('has-access-to-additional-pages')){
          linktoadditonalpages = "/additional-pages";
        }

        this.items[this.items.findIndex(o=>o.text == 'Admin')]['children'].push({ icon: "mdi-book-open-variant", text: "Additional Pages", link: linktoadditonalpages })
      }

      if(this.currentUser.roles.includes(1)){
        this.items[this.items.findIndex(o=>o.text == 'Admin')]['children'].push(
          { icon: "mdi-cog", text: "Settings", link: "/Settings" },
        )
      }

      let linktomail = '/system-email-template';
      if(this.currentUser.roles.includes(1) || this.currentUser.permission_labels.includes('custom-email-scheduling')){
        
        if(this.currentUser.permissions.includes('has-access-to-reminder-mails')){
          linktomail = "/reminder";
        }

        if( this.currentUser.permissions.includes('has-access-to-trigger-mails')){
          linktomail = "/trigger-mail-template";
        }
                
        if( this.currentUser.permissions.includes('has-access-to-scheduled-mails')){
          linktomail = "/scheduled-mail-notification";
        }

        if(this.currentUser.permissions.includes('has-access-to-system-mails')){
          linktomail = "/system-email-template";
        }

        if(this.currentUser.permissions.includes('has-access-to-all-mail-types')){
          linktomail = "/system-email-template";
        }

        this.items[this.items.findIndex(o=>o.text == 'Admin')]['children'].push(
          { icon: "mdi-email", text: "Mails", link: linktomail },
        )
      }

      if (this.currentUser.company.account_type == "on-demand") {
        if(this.currentUser.roles.includes(1)){
          this.items.push(
              {
              icon: 'mdi-wallet-giftcard',
              text: 'Vouchers',
              model: false,
              children: [
                { icon: "mdi-wallet-membership", text: "Buy Course Vouchers", link: "/vouchers" },
                { icon: "mdi-clipboard-check", text: "Manage Course Vouchers", link: "/coupons" },
                { icon: "mdi-ticket", text: "Buy Tutor Vouchers", link: "/tutor-vouchers" },
                { icon: "mdi-ticket-account", text: "Manage Tutor Vouchers", link: "/tutor-coupons" }
              ],
            }
          )
        }
      }
      

    },
    async selLanguage(language) {
      await this.$store.commit(SET_CUR_LANGUAGE, language);
    },
    async contactQuery() {
      if (this.$refs.contactForm.validate()) {
        let params = {
            subject: this.subject,
            body: this.body,
            send_copy: this.sendCopy,
          };
        if(this.sendGroup=='group'){
          params["group_ids"] = this.userGroupList.toString();
        }
        else if(this.sendGroup=='users'){
          params["user_ids"] = this.userList.toString();
        }

        if(this.canSendMessages){
          params["user_ids"] = this.userList.toString();
        }

        this.$store
          .dispatch(CONTACT_QUERY, params)
          .then(resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
              this.message = "Query successfully sent";
              this.navSuccessMessageDialog = true;
              this.contact = false;
              this.$store.commit(SET_LOADING, false);
            }
            else{
              this.$store.commit(SET_LOADING, false);
            }
          });
      }
    },
    setDropdown() {
      // Set Company Admin Pages 
      let pages = this.pagesdata.filter(o => o.page_slug !== 'legalnotice').map(function(obj) {
          return {
            icon: obj.icon_code,
            type: 'Pages',
            text: obj.page_title,
            action: obj.page_slug
          };
      });

      if (this.currentUser.company.account_type == "on-demand") {
        this.dropdown = [
          { icon: "mdi-account-box", type: "profile", text: "Profile", action: "profile" },
          { icon: "mdi-calculator", type: "Invoices", text: "Invoices", action: "invoices" },
        ];
      } else {
        this.dropdown = [
          { icon: "mdi-account-box", type: "Profile", text: "Profile", action: "profile" }
        ];
      }

      pages.forEach(item => this.dropdown.push(item));

      this.sideMenuAddPages = this.additionalpagessidemenu;

      // Set Extra Company Pages set by the company
      let addpages = this.additionalpages.filter(o => o.show_on_side_menu == 0).map(function(obj) {
          return {
            icon: obj.page_type=='blank' ? "mdi-file-outline" : obj.page_type=='glossary' ? 'mdi-clipboard-list' : 'mdi-account-question',
            type: "CompanyPages",
            text: obj.page_names[0] ? obj.page_names[0].page_name : '',
            action: obj.page_id
          };
      });

      
        addpages.forEach(item => this.dropdown.push(item));
        //Logout 
        this.dropdown.push({
          icon: "mdi-power",
          type: "Logout",
          text: "Logout",
          action: "logout"
        });

    },
    fetchPages() {
      this.$store
        .dispatch(FETCH_PAGES, "?lang_ids=" + this.curLanguage.lang_id).then(resp => {
          if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
            this.setDropdown()    
            this.$store.commit(SET_LOADING, false)
          }
        });

        this.$store
        .dispatch(FETCH_ADDITIONAL_PAGES, "?replace_content=true").then(resp => {
          if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
            this.setDropdown()    
            this.$store.commit(SET_LOADING, false)
          }
        });
    },
    convertfromTztoDate(dateString){
      const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
      const date = new Date(dateString);
      const formattedDate = date.toLocaleDateString('en-US', options);

      // Extract year, month, and day parts and join them with '-'
      const [month, day, year] = formattedDate.split('/');
      return `${year}-${month}-${day}`;
    },
    async changedLanguage(value) {
          this.currentUser.lang_code = this.selectedLanguage.lang_code;
          this.currentUser.logged_at = this.currentUser.logged_at? this.convertfromTztoDate(this.currentUser.logged_at) : null;
          const user  = this.currentUser;
           await this.$store
        .dispatch(UPDATE_USER_STATUS,{
            _method: "put", ...user
          })
        .then(resp => {
          if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
            this.fetchPages();
      
            this.$store.dispatch(FETCH_ADDITIONAL_PAGES_ON_SIDE_MENU,"?show_on_side_menu=true&replace_content=true")
            .then(resp => {
              if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
                store.state.additionalpagessidemenu = resp.data;
              }
            });
            this.setDropdown();

            //change current logged in User data to new fetched data, as we now make switcher act as user preffered langugae
            this.$store.dispatch(UPDATE_CUR_USER_LANG, {
              user_id: this.currentUser.user_id,
              lang_code: this.selectedLanguage.lang_code,        
            })
            this.setLanguageDropdown();
       
            this.$store.commit(SET_LOADING, false)
          }
        }); 
        
      Vue.i18n.set(value);
      let selectedLanguage = this.languages.find(x => value === x.lang_code);

      await this.$store.commit(SET_CUR_LANGUAGE, selectedLanguage);
      await store.dispatch(PAGES_RESET_STATE);
      await this.$store
        .dispatch(FETCH_PAGES, "?lang_ids=" + this.curLanguage.lang_id)
        .then(resp => {
          if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
            this.setDropdown();
            this.$store.commit(SET_LOADING, false)
          }
        });
        location.reload();

    },
    onResize() {
      this.isMobile = window.innerWidth < 600;
      if (this.isMobile) {
        this.collapseStatus = true;
        store.commit(SET_NAVBAR_WIDTH, 0);
      } else {
        this.collapseStatus = false;
        store.commit(SET_NAVBAR_WIDTH, 80);
      }
    },
    async action(status, type) {
      switch (type) {
        case "Profile":
          this.$router.push("/profile");
          break;
        case "Invoices":
          this.$router.push("/invoices");
          break;
        case "Logout":
          Promise.all([   
            await this.$store.commit(SET_LOGGED_IN, false),    
            await this.$store.dispatch(LOGOUT),
            await this.$store.dispatch(STRIPE_RESET_STATE),
            await  this.$store.commit(RESET_ALL_PAGES_DATA),
            await  this.$store.commit(RESET_ALL_ADDITIONAL_PAGES_DATA),
            await this.$store.dispatch(PAGES_RESET_STATE),
            await this.$store.dispatch(RESET_STATE),
            await this.$store.dispatch(GLOBALS_RESET_STATE), 
          ]).finally(() => { 
            this.$router.push("/login");
          });
          break;
        case "CompanyPages":
          this.$router.push("/companypages/"+ status);
          break;
        default:
          this.$router.push("/pages/" + type);
      }
    },
    status: function() {
      this.$store.dispatch(FETCH_NAVIGATION_BAR_STATUS);
    }

  },
  computed: {
    ...mapGetters([
      "mini",
      "languages",
      "currentUser",
      "widthValue",
      "pagesdata",
      "additionalpages",
      "additionalpagessidemenu",
      'curLanguage',
    ]),
    openDrawer: {
      get: function () {
        return this.mini
      },
      set: function () {
        //this.$store.dispatch(FETCH_NAVIGATION_BAR_STATUS)
      }
 
    },
    inboxMessagesCount () {
       return this.$store.getters.openMessageCount;
    },
    languageLabel(){
      return this.$t('Language')
    },
    languagesdata(){
      return this.languages.map(data =>{
        return{
         'lang_code': data.lang_code,
         'lang_id':  data.lang_id,
         'lang_name': this.$t(data.lang_name),
        }
     
      })
    },
    recipientType(){
      return [
          {value: 'group', text:this.$t('Group')},
          {value: 'users', text:this.$t('Users')}
      ]
    },
    isAuthenticated: function() {
      return this.$store.getters.isAuthenticated;
    },
    isCompanyRep: function() {
      return (this.currentUser.roles.includes(1) || this.currentUser.roles.includes(3));
    },
    canSendMessages: function() {
      return true; // now always users will see a dropdown list
    },
  }
};
</script>

<style scoped>
.badge {
  padding: 2px 5px;
  font-weight: bold;
}
</style>
